<template>
    <div class="col-lg-8 col-12 mb-3 pr-lg-0">
        <div class="card shadow-sm border-0">
            <div class="card-body p-0">
                <div class="header-activity py-4 px-3 d-md-flex">
                    <h6 class="font-weight-bold">Contributors
                        <span class="small font-weight-bold">({{ contributors.members.length }})</span>
                    </h6>

                    <h6 class="ml-auto"> 
                        <span class="text-muted small">Payable: </span> 
                        <span class="font-weight-bold">&#8358;{{ pool.amount_payable | moneyformat }}</span> each
                    </h6>
                </div>
                <!-- use a table here -->
                <div class="pl-2">
                    <table class="table table-responsive">
                        <thead>
                            <tr class="">
                                <!-- <th scope="col">#</th> -->
                                <th scope="col">Name</th>
                                <th scope="col">Invite Status</th>
                                <th scope="col">Contribution</th>
                                <th scope="col" v-if="isConvener">Reminders</th>
                                <!-- <th scope="col" v-if="pool.payout_rule == 'majority-vote'">Payout Vote</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(contributor, index) in contributors.members" :key="index">
                                <!-- <td scope="row">{{ index + 1}}</td> -->
                                <td style="width: 300px;">
                                    <div class="avatar-container d-flex align-items-start">
                                        <div class="avatar-container mr-3">
                                            <img src="@/assets/avatar-purple.png" class="avatar" alt="avatar" style="height:40px; width: 40px;">
                                        </div>
                                        <div class="d-flex flex-column">
                                            <p class="m-0">{{ contributor.name }}</p>
                                            <p class="small text-muted m-0">{{ contributor.phone }}</p>
                                        </div>
                                    </div>
                                </td>
                                <td> <span :class="`${contributor.is_invite_accepted ? 'badge badge-success': 'badge badge-light' }`">{{ contributor.is_invite_accepted ? 'Accepted' : 'Pending'}}</span></td>
                                <td>
                                    <span class="badge" :class="contributor.paid_status == false ? 'badge-light': 'badge-success'">
                                        {{ contributor.paid_status == false ? 'Pending' : 'Received' }} 
                                    </span>
                                </td>
                                <td v-if="isConvener">
                                    <button class="btn btn-link btn-sm" 
                                        @click.prevent="sendAcceptReminder(contributor.invite_id)">
                                        Send
                                    </button>
                                </td>
                                <!-- <td><button class="btn btn-light btn-sm" v-if="pool.payout_rule == 'majority-vote'">Vote</button></td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contributors: {
            type: Object,
            required: true
        },
        pool: {
            type: Object,
        },
    },
    watch: {
        pool: {
            immediate: true,
            handler() {
                this.$store.dispatch('getPoolConvener', this.pool.account_id);
            }
        }
    },
    computed: {
        userProfile() {
            return this.$store.getters.userProfile
        },
        isConvener() {  
            let pool = this.pool;

            if (pool == null) {
                return false
            } else {
                return pool.account_id != this.userProfile.account_id ? false : true
            }
        }
    },
    methods: {
        async sendAcceptReminder(invite_id) {
            const data = { 
                pool_id: this.pool.pool_id,
                invite_id: invite_id,
            }
            try {
               const reminder = await axios.post('/notifications/send/pool-accept-invite', data);

               if (reminder.status == 200 && 'message' in reminder.data) {
                    const { message } = reminder.data;

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: `${message}`
                    }) 
               }
                
            } catch (error) {
                console.log(error.response);
            }
        }
    }
}
</script>

<style scoped> 

.table thead th {
    vertical-align: bottom;
    border-bottom:  1px solid #eee;
    font-size: 14px;
    font-weight: 500;
}
.table td, .table th {
    padding: .75rem;
    vertical-align: top;
    border-top: none !important;
}

</style>